import { ToastService } from "ng-components-tsi"
import { validarVacioAndNull } from "shared-tsi"

export interface ValidationConfig {
    list?: any[]
    value: any
    listName?: string
    key?: string
    validationType?: 'list' | 'dateFormat' | 'dateRange' | 'required' | 'periodLength' | 'listSelection' | 'notZero'
    compareWith?: any
    requiredMessage?: string
    rejectNoption?: string
    listSelectionMessage?: string
    notZeroMessage?: string
}
function validateItem(config: ValidationConfig): boolean {
    switch (config.validationType) {
        case 'dateRange':
            if (!config.compareWith) return true
            return isDateBeforeOrEqual(config.value, config.compareWith)
        case 'required':
            return !!config.value
        case 'periodLength':
            return config.value?.toString().length == 4
        case 'listSelection':
            return !!config.value
        case 'notZero':
            return config.value != 0 && config.value != '0'
        case 'list':
        default:
            return validateSingle(config)
    }
}

function getErrorMessage(config: ValidationConfig): string {
    switch (config.validationType) {
        case 'dateFormat':
            return `El formato de fecha para ${config.listName} no es válido (yyyy-mm-dd).`
        case 'dateRange':
            const formattedDate = formatDateToDDMMYYYY(config.compareWith)
            return `La fecha ${config.listName} debe ser anterior o igual a ${formattedDate}.`
        case 'required':
            return config.requiredMessage || `El campo ${config.listName} es obligatorio.`
        case 'periodLength':
            return `El campo ${config.listName} debe tener 4 caracteres.`
        case 'listSelection':
            return config.listSelectionMessage || `Debe seleccionar un elemento de la lista de ${config.listName}.`
        case 'notZero':
            return config.notZeroMessage || `El valor de ${config.listName} no puede ser cero.`
        default:
            return `El código de ${config.listName} no existe.`
    }
}

export function formatDateToDDMMYYYY(dateString: string): string {
    if (!dateString) return dateString

    const parts = dateString.split('-')
    if (parts.length == 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`
    }
    return dateString
}

function validateSingle(config: ValidationConfig): boolean {
    const { list, value, key, rejectNoption } = config
    if (rejectNoption && (value == null || value == undefined)) {
        return false
    }
    if (value == null || value == undefined || value == '' || value == -1) {
        return true
    }

    if (key) {
        return list?.some(item => item[key] == value) ?? false
    } else {
        return list?.includes(value) ?? false
    }
}

function isDateBeforeOrEqual(startDateStr: string, endDateStr: string): boolean {
    if (!startDateStr || !endDateStr) return true

    const [year1, month1, day1] = startDateStr.split('-').map(Number)
    const [year2, month2, day2] = endDateStr.split('-').map(Number)

    const date1 = new Date(year1, month1 - 1, day1)
    const date2 = new Date(year2, month2 - 1, day2)

    return date1 <= date2
}

const posiblesValores = ['center', 'start', 'end'] as const;
const posiblesValoresTipoInput = ['text', 'text-area', 'date', 'number', 'select', 'number-format-decimal', 'number-integer'] as const;

export function validaPeriodo(periodo: number): boolean {
    if (!periodo) return false
    if (periodo > 9999 || periodo < 999) return false
    return true
}
export function validaArray(data: any): boolean {
    return Array.isArray(data) && data.length > 0
}

export function getFirstItem<T>(data: T[]): T | null {
    if (!validaArray(data)) {
        return null;
    }
    return data[0]
}

export function sanitizeBody(body: any) {
    if (!body) return null
    const clone = { ...body }
    delete clone.password
    delete clone.token
    return clone
}
